import { render, staticRenderFns } from "./DeleteTopicDialog.vue?vue&type=template&id=6ef2fccb&scoped=true&"
import script from "./DeleteTopicDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteTopicDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef2fccb",
  null
  
)

export default component.exports